import update from 'immutability-helper';
import cookies from 'browser-cookies';

export const AUTHENTICATION_API_SUCCESS = 'AUTHENTICATION_API_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const TOKEN_COOKIE_PROPERTY = 'token';
export const ROLE_COOKIE_PROPERTY = 'role';
export const NO_STATS_COOKIE_PROPERTY = 'no_stats';
export const ID_COOKIE_PROPERTY = 'id';

const defaultState = { user: {} };
export const erase = () => {
  cookies.erase(TOKEN_COOKIE_PROPERTY);
  cookies.erase(ROLE_COOKIE_PROPERTY);
  cookies.erase(NO_STATS_COOKIE_PROPERTY);
  cookies.erase(ID_COOKIE_PROPERTY);
};

export const reducer = (state = defaultState, { type, response }) => {
  switch (type) {
    case AUTHENTICATION_API_SUCCESS:
      cookies.set(TOKEN_COOKIE_PROPERTY, response.token);
      cookies.set(ROLE_COOKIE_PROPERTY, response.role);
      cookies.set(NO_STATS_COOKIE_PROPERTY, response.no_stats ? response.no_stats.toString() : 'false');
      cookies.set(ID_COOKIE_PROPERTY, response.id.toString());
      return update(state, { user: { $set: response } });
    case LOGOUT:
      erase();
      return state;
    default:
      return state;
  }
};

export const isAuthenticated = () => (!!cookies.get(TOKEN_COOKIE_PROPERTY));
export const token = () => cookies.get(TOKEN_COOKIE_PROPERTY);
export const role = () => cookies.get(ROLE_COOKIE_PROPERTY);
export const showStats = () => cookies.get(NO_STATS_COOKIE_PROPERTY) !== 'true';
export const userId = () => cookies.get(ID_COOKIE_PROPERTY);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/currentUser/currentUser.reducer.js